<template>
  <div style="padding-left: 1.75rem">
    <div class="col2_head">
      <router-link :to="'/'" class="breadcrumb_home">Acasă /</router-link>
      {{ $route.name }}
      <div class="subHeadTitle">{{ $route.name }}</div>
    </div>
    <div class="Profile_Parent panel Administration_panel">
      <div class="inner_panel">
        <div
          style="
            display: flex;
            justify-content: flex-start;
            align-items: center;
          "
        >
          <div class="protectedStatus">
            <img @load="imgLoaded" src="../assets/media/protected.svg" alt="" />
            {{ getBeautifiedRole() }}
          </div>
        </div>

        <h4 style="margin-bottom: 0.5rem">Utilizatori</h4>

        <div
          :class="0 ? 'Administration_section_loading' : ''"
          class="Administration_panel_section"
        >
          <div v-if="isSuperadmin" class="form-group">
            <b class="asterisk">Instituția </b>
            <v-select
              :options="institutionaData"
              label="name"
              v-model="currentInstitution"
              append-to-body
            >
              <template #option="{ name }">
                <span class="v-select_li_custom">
                  <span>{{ name }}</span>
                  <i v-tooltip="name" class="fas fa-info-circle"></i>
                </span>
              </template>
            </v-select>
          </div>

          <div class="form-flex form-adapt-2">
            <div class="form-group">
              <b>Structura organizatorică</b>
              <v-select-infinite
                v-model="currentDepartment"
                label="name"
                :apiModule="departmentsApiModule"
              >
              </v-select-infinite>
            </div>

            <div class="form-group">
              <b>Nume utilizator</b>
              <div class="form-flex">
                <div class="RForm">
                  <input
                    v-model="nameToSearch"
                    type="text"
                    @keydown.enter="searchByName"
                    class="vInput"
                  />
                  <i @click="searchByName" class="fas fa-search"></i>
                </div>
                <button
                  v-tooltip="{ content: 'Exclude utilizatori selectați' }"
                  class="Button3 delete-user-btn"
                  :disabled="!usersToRemove.length"
                  :class="{ 'button-disabled': !usersToRemove.length }"
                  @click="removeUsers"
                >
                  <i class="fas fa-user-minus" style="margin: auto"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <input
              id="user_bad_data"
              type="checkbox"
              style="margin-right: 5px"
              @change="onChangeBadDataView"
            />
            <label for="user_bad_data"
              >Afișează doar utilizatorii cu date incorecte
            </label>
          </div>
          <h5 v-if="showTotalRecords">Total utilizatori: {{ totalRecords }}</h5>

          <div class="users-container">
            <div
              v-for="item in filteredModels"
              class="Administration_panel_block user-info"
              :key="item.conectxid.value"
            >
              <input
                type="checkbox"
                :value="item.conectxid.value"
                v-model="usersToRemove"
                v-tooltip="{
                  content: 'Selectează utilizatorul pentru a fi exclus',
                }"
              />
              <div class="form-group" :class="{ WRNG: item.conectxid.invalid }">
                <b>ConectX ID</b>
                <div style="display: flex; align-items: center">
                  <input
                    type="number"
                    v-model="item.conectxid.value"
                    class="vInput form-disabled"
                    disabled
                    min="0"
                  />
                </div>
              </div>
              <div class="form-group" :class="{ WRNG: item.name.invalid }">
                <b>Nume</b>
                <input
                  v-model="item.family.value"
                  class="vInput form-disabled"
                  autocomplete="new-password"
                  autocapitalize="false"
                  autocorrect="false"
                  disabled
                />
              </div>
              <div class="form-group" :class="{ WRNG: item.family.invalid }">
                <b>Prenume</b>
                <input
                  type="text"
                  v-model="item.name.value"
                  class="vInput form-disabled"
                  autocomplete="new-password"
                  autocapitalize="false"
                  autocorrect="false"
                  disabled
                />
              </div>
              <div class="Popup_body_col">
                <div
                  class="form-group"
                  :class="{ WRNG: item.username.invalid }"
                >
                  <b>Username</b>
                  <div
                    class="form-status"
                    :class="{
                      fActive: item.statuses.usernameIsUnique !== false,
                      fPositive: item.statuses.usernameIsUnique === 1,
                      fNegative: item.statuses.usernameIsUnique === 2,
                    }"
                  >
                    <input
                      type="text"
                      v-model="item.username.value"
                      class="vInput form-disabled"
                      autocomplete="new-password"
                      autocapitalize="false"
                      autocorrect="false"
                      disabled
                    />
                    <span>
                      <i
                        v-if="item.statuses.usernameIsUnique === true"
                        class="fas fa-sync fa-spin"
                      ></i>
                      <i
                        v-if="item.statuses.usernameIsUnique === 1"
                        class="fas fa-check"
                        style="color: #43b645"
                        v-tooltip="'Acest username este unic!'"
                      ></i>
                      <i
                        v-if="item.statuses.usernameIsUnique === 2"
                        class="fas fa-times-circle"
                        style="color: #c84d4d"
                        v-tooltip="{
                          content: 'Acest username deja există!',
                          offset: 2,
                        }"
                      ></i>
                    </span>
                  </div>
                </div>
                <div class="form-group" :class="{ WRNG: item.email.invalid }">
                  <b
                    >E-mail corespondență
                    <template v-if="item.email.value">
                      <i
                        v-if="item.statuses.emailIsValid"
                        class="fas fa-check-circle"
                        v-tooltip="'Formatul este introdus corect.'"
                        style="color: #43b645"
                      ></i>
                      <i
                        v-else
                        class="fas fa-times-circle"
                        v-tooltip="'Formatul nu este introdus corect.'"
                        style="color: #c84d4d"
                      ></i> </template
                  ></b>
                  <div
                    class="form-status"
                    :class="{
                      fActive: item.statuses.emailIsUnique !== false,
                      fPositive: item.statuses.emailIsUnique === 1,
                      fNegative: item.statuses.emailIsUnique === 2,
                    }"
                  >
                    <input
                      type="text"
                      v-model="item.email.value"
                      class="vInput form-disabled"
                      autocomplete="new-password"
                      autocapitalize="false"
                      autocorrect="false"
                      disabled
                    />
                    <span>
                      <i
                        v-if="item.statuses.emailIsUnique === true"
                        class="fas fa-sync fa-spin"
                      ></i>
                      <i
                        v-if="item.statuses.emailIsUnique === 1"
                        class="fas fa-check"
                        style="color: #43b645"
                        v-tooltip="'Acest email este unic!'"
                      ></i>
                      <i
                        v-if="item.statuses.emailIsUnique === 2"
                        class="fas fa-times-circle"
                        style="color: #c84d4d"
                        v-tooltip="{
                          content: 'Acest email deja există!',
                          offset: 2,
                        }"
                      ></i>
                    </span>
                  </div>
                </div>
                <div
                  class="form-group VTY-margin_1"
                  :class="{ WRNG: item.phone.invalid }"
                >
                  <b
                    >Telefon
                    <template v-if="item.phone.value">
                      <i
                        v-if="item.statuses.phoneStatus?.valid === true"
                        class="fas fa-check-circle"
                        v-tooltip="'Formatul este introdus corect.'"
                        style="color: #43b645"
                      ></i>
                      <i
                        v-else
                        class="fas fa-times-circle"
                        v-tooltip="'Formatul nu este introdus corect.'"
                        style="color: #c84d4d"
                      ></i>
                    </template>
                  </b>
                  <vue-tel-input
                    @input="(_, b) => checkPhone(b, item)"
                    v-model="item.phone.value"
                    :inputOptions="{
                      styleClasses: 'form-disabled',
                    }"
                    disabled
                  />
                </div>
              </div>
              <div class="right" style="margin-top: 5px">
                <button
                  v-tooltip="{ content: 'Sincronizare utilizator' }"
                  class="Button2"
                  @click.prevent="syncUser(item)"
                  style="margin-right: 5px"
                >
                  <i
                    class="fas fa-sync"
                    :class="{ rotating: item.loadUser }"
                  ></i>
                </button>
                <button
                  @click="removeUser(item.conectxid.value)"
                  class="Button3"
                >
                  <i
                    v-tooltip="'Exclude utilizator'"
                    class="fas fa-user-minus"
                  ></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          style="margin: auto; display: flex; justify-content: center"
          v-if="currentInstitution && models.length == 0"
        >
          <div class="Button2" @click="importUsers">
            <span class="Btn_content"> Importă utilizatori </span>
          </div>
        </div>

        <div class="right" v-if="models.length > 0">
          <div @click="saveData()" class="Button1">
            <div class="icon">
              <img
                @load="imgLoaded"
                src="../assets/media/for_table/circle_ADD_new_etap.svg"
                alt=""
              />
            </div>
            <span class="Btn_content">
              {{ btnText }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  INSTITUTIONS_PAGINATED,
  IMPORT_USERS,
  SAVE_USERS,
  USER_SYNC,
  DEPARTMENTS_PAGINATED,
} from "@/api.js";
import updateRoleStatus from "../mixins/updateUserRoleStatus.js";
import DialogModal from "@/components/DialogModal";

const defaultStatuses = () => ({
  usernameIsUnique: false,
  emailIsUnique: false,
  emailIsValid: false,
  phoneStatus: false,
});

export default {
  mixins: [updateRoleStatus],
  data() {
    return {
      showOnlyBadData: false,
      usersToRemove: [],
      models: [],
      institutionaData: [],
      currentInstitution: null,
      currentDepartment: null,
      nameToSearch: "",
      departmentsApiModule: (page, limit, _query) => {
        let query = `eq=institutionId,${this.currentInstitution?.id}`;
        if (_query) {
          query += `&${_query}`;
        }
        return DEPARTMENTS_PAGINATED(page, limit, query);
      },
    };
  },

  watch: {
    currentInstitution: {
      async handler(val) {
        if (val && val.id) {
          this.importUsers();
        } else {
          this.models = [];
        }
      },
      deep: true,
      immediate: true,
    },

    currentDepartment: {
      async handler(current, old) {
        if (current || old) {
          this.importUsers();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    filteredModels() {
      if (this.showOnlyBadData) {
        return this.models.filter(
          (el) => !el.statuses.emailIsValid || el.phone.invalid
        );
      }
      return this.models;
    },
    btnText() {
      return "Salvează";
    },
    showTotalRecords() {
      return Number.isInteger(this.totalRecords);
    },
    totalRecords() {
      return this.filteredModels.length;
    },
  },
  methods: {
    closePanel() {
      const path = this.$route.path;
      this.$router.push(path.slice(0, path.lastIndexOf("/")));
    },

    getInitialEditingData() {
      const x = this.options.data;

      return {
        ...x,
        institution: x?.institution?.id ?? null,
      };
    },

    getModelsData() {
      const excludes = [];
      const models = { ...this.models };

      excludes.forEach((e) => delete models[e]);

      if (this.isSuperadmin) {
        currentInstitution = currentInstitution?.id ?? null;
      }

      return models;
    },

    saveData() {
      for (const model of this.models) {
        if (model.email.invalid || model.phone.invalid) {
          this.$toastr.w("Există utilizatori ce au date incorecte.");
          return;
        }
      }

      const body = {
        users: this.models.map((e) => e.conectxid.value),
      };

      if (this.isSuperadmin) {
        body.institutionId = this.currentInstitution.id;
      }

      this.setLoad(true);
      SAVE_USERS(body).then((res) => {
        if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
          this.$toastr.s(`Au fost salvați ${res.data} de utilizatori.`);
          this.closePanel();
        } else {
          this.$toastr.e(res.response || "Salvarea utilizatorilor a eșuat.");
        }
        this.setLoad();
      });
    },
    syncInstitutions() {
      const warn = (msg, isWarning) => {
        if (isWarning) {
          this.$toastr.w(msg || "Nu sunt instituții disponibile de selectat.");
        } else {
          this.$toastr.e(msg || "Datele instituțiilor nu au fost primite.");
          this.closePanel();
        }
      };

      INSTITUTIONS_PAGINATED(1, 5000)
        .then((res) => {
          if (Array.isArray(res?.data?.result)) {
            res = res.data.result;

            if (res.length) {
              this.institutionaData = res.map((e) => ({
                ...e,
                id: e.id ?? this.makeid(8),
                name: e.name ?? "-",
              }));
            } else {
              warn(false, true);
            }
          } else {
            warn();
          }
        })
        .catch(warn);
    },

    importUsers() {
      this.setLoad(true);

      this.models = [];

      let query = null;

      if (this.isSuperadmin) {
        query = `?institutionId=${this.currentInstitution.id}`;
      }

      IMPORT_USERS(query)
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            if (res.data.length === 0) {
              this.$toastr.w("Toți utilizatorii au fost importați.");
              this.setLoad();
              return;
            }

            const models = [];

            for (let i = 0; i < res.data.length; i++) {
              const item = res.data[i];

              if (
                this.currentDepartment &&
                this.currentDepartment.name != item.department
              ) {
                continue;
              }

              if (
                this.nameToSearch &&
                !this.normalize(item.first_name)
                  .toLowerCase()
                  .includes(
                    this.normalize(this.nameToSearch.trim().toLowerCase())
                  ) &&
                !this.normalize(item.last_name)
                  .toLowerCase()
                  .includes(
                    this.normalize(this.nameToSearch.trim().toLowerCase())
                  )
              ) {
                continue;
              }

              const _user = {
                name: { value: item.first_name, invalid: false },
                family: { value: item.last_name, invalid: false },
                username: { value: item.username, invalid: false },
                email: { value: item.email, invalid: false },
                phone: { value: item.phone, invalid: false },
                conectxid: { value: item.id, invalid: false },
                statuses: defaultStatuses(),
                loadUser: false,
              };

              const emailValidate = this.validateEmail(item.email);
              _user.statuses.emailIsValid = emailValidate;

              models.push(_user);
            }

            this.models = models;
          } else {
            this.$toastr.e(res.response);
          }
          this.setLoad();
        })
        .catch((err) => {
          console.log(err);

          this.$toastr.e(
            "Importul utilizatorilor a eșuat. Încercați mai târziu."
          );
          this.setLoad();
        });
    },

    removeUser(id) {
      const index = this.models.findIndex((e) => e.conectxid.value === id);

      if (index === -1) {
        return;
      }

      const userToDelete = this.models[index];

      this.$modal.show(
        DialogModal,
        {
          target: "EXCLUDE_USER",
          content: `<h2>Doriți să excludeți funcționarul: <br> ${userToDelete.name.value} ${userToDelete.family.value}?</h2>`,
          closeBtnText: "Anulează",
          button: {
            type: 3,
            value: "Elimină",
            handler: () => {
              this.models.splice(index, 1);
            },
          },
        },
        {
          name: "EXCLUDE_USER",
          adaptive: true,
          width: "650",
          height: "400",
        }
      );
    },

    removeUsers() {
      this.$modal.show(
        DialogModal,
        {
          target: "EXCLUDE_USER",
          content: `<h2>Doriți să excludeți funcționarii selectați?</h2>`,
          closeBtnText: "Anulează",
          button: {
            type: 3,
            value: "Elimină",
            handler: () => {
              for (const id of this.usersToRemove) {
                const index = this.models.findIndex(
                  (e) => e.conectxid.value === id
                );

                if (index === -1) {
                  continue;
                }

                this.models.splice(index, 1);
              }

              this.usersToRemove = [];
            },
          },
        },
        {
          name: "EXCLUDE_USER",
          adaptive: true,
          width: "650",
          height: "400",
        }
      );
    },

    checkPhone(e, item) {
      const index = this.models.findIndex(
        (el) => el.conectxid.value === item.conectxid.value
      );

      if (index === -1) {
        return;
      }

      this.models[index].phone.invalid = !e.valid;
      this.models[index].statuses.phoneStatus = e;
    },

    async syncUser(item) {
      const index = this.models.findIndex(
        (el) => el.conectxid.value === item.conectxid.value
      );

      if (index === -1) {
        return;
      }

      const error = (msg) => {
        if (msg) this.$toastr.e(msg);
        this.setLoad();
        this.models.loadUser = false;
      };

      this.models[index].loadUser = true;

      this.setLoad(true);

      await USER_SYNC({
        institutionId: this.currentInstitution.id,
        conectxId: item.conectxid.value,
      })
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            const userInfo = res.data;

            this.models[index].loadUser = false;
            this.models[index].name.value = userInfo.first_name;
            this.models[index].family.value = userInfo.last_name;
            this.models[index].username.value = userInfo.username;
            this.models[index].email.value = userInfo.email;
            this.models[index].phone.value = userInfo.phone;

            const emailValidate = this.validateEmail(userInfo.email);
            this.models[index].statuses.emailIsValid = emailValidate;

            this.setLoad();
          } else {
            error(res.response.message);
          }
        })
        .catch((err) => {
          error(err.message);
        });
    },

    searchByName() {
      if (!this.currentInstitution) return;
      this.importUsers();
    },

    onChangeBadDataView(event) {
      this.showOnlyBadData = event.target.checked;
    },
  },

  created() {
    this.updateRoleStatus();

    this.$nextTick(() => {
      if (this.isSuperadmin) {
        this.syncInstitutions();
      } else {
        const userInstitution = this.getUserInstitution(true);
        this.currentInstitution = userInstitution ?? null;
      }
    });
  },
  mounted() {
    const path = this.$route.path;
    const val = path.slice(0, path.lastIndexOf("/"));
    this.$root.$emit("select-item", val);
  },
};
</script>

<style src="../assets/profile.css"></style>
<style src="../assets/administration.css"></style>

<style lang="scss">
.users-container {
  max-height: 400px;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 15px;

  .Administration_panel,
  .Administration_panel_block {
    width: auto;
  }
}

@media screen and (max-width: 600px) {
  .delete-user-btn {
    margin-top: 1rem;
    width: 100%;
    display: flex;
  }
}

.users-container::-webkit-scrollbar {
  width: 8px !important;
}

.users-container::-webkit-scrollbar-track {
  background: rgba(121, 60, 60, 0.05);
}

.users-container::-webkit-scrollbar-thumb {
  background: rgba(121, 60, 60, 0.05);
}

.users-container::-webkit-scrollbar-thumb:hover {
  background: rgba(121, 60, 60, 0.05);
}
</style>
